import React, { useCallback, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper"
import Columns from './Columns'
import AddUpdModal from './AddUpdModal'
import { resourcesInstallations,getUsers,getSelectsInstallation } from '../../helpers/backend_helper';
import {DestroyAlertHelper,Alert,ToastHelper} from '../../helpers/alerts/alertHelper';
import { getPolicyUser } from '../../helpers/api_helper';
import {Container} from "reactstrap";
import Select from 'react-select';
import PreviewPDF from '../../helpers/previewPDF';
import ButtonHelper from "../../components/Common/ButtonHelper";


const Installations = () => {
    let timeElapsed = new Date();
    let dateNow = `${timeElapsed.getFullYear()}-${timeElapsed.getMonth()+1 < 10 ? '0':''}${timeElapsed.getMonth()+1}-${timeElapsed.getDate() < 10 ? '0':''}${timeElapsed.getDate()}`;
    let temp = new Date(timeElapsed)
    let ant= 7 * -86399.9 //dias en segundos
    let finalDate = new Date(temp.setSeconds(ant))
    let dateNowFormat = `${finalDate.getFullYear()}-${finalDate.getMonth()+1 < 10 ? '0':''}${finalDate.getMonth()+1}-${finalDate.getDate() < 10 ? '0':''}${finalDate.getDate()}`;
    const [tecnico, setTecnico] = useState(null);
    const [ruta, setRuta] = useState(null);
    const [selects, setSelects] = useState({tecnicos:[],rutas:[]});
    const policy = getPolicyUser();
    const [pending, setPending] = useState(false);
    const [modal, setModal] = useState({show:false,update:false});
    const [modalPdf, setModalPdf] = useState({show:false,update:false});
    const [dataPag, setDataPag] = useState({});
    const [filters,setFilters] = useState({page:1,perPage:20,search:'',orderBy:'id',order:'desc',initDate:dateNowFormat,endDate:dateNow,tecnico_id:null,no_ruta:null});
    const [items, setItems] = useState([]);
    const [itemBase, setBase] = useState({
        id: 0,
        fecha:'',
        tipo_id:null,
        no_ruta:'',
        domicilio:'',
        estado_id:null,
        municipio:'',
        marca:'',
        color:'',
        placas:'',
        unidad:'',
        concesion:'',
        tipo_bloqueo:'',
        celular:'',
        imei:'',
        serie:'',
        no_motor:'',
        chip:'',
        edo:'',
        usuario_id:null,
        equipamiento_id:null,
        modelo:'',
        ubicacion_gps:'',
        empresa:'',
        anio:'',
        colonia:'',
        company_id:null,
        tecnicos: [],
    });

    const [item, setItem] = useState(itemBase);
	const dispatch = useDispatch()

    const getInstallations = useCallback(
      () => {
        let params={params:filters}
        setPending(true)
        resourcesInstallations('get',params).then(response => {
            setItems(response.data)
            setDataPag(response.meta)
            setPending(false)
        });
      },
      [filters]
    );
    
    

    useEffect(() => {
        getInstallations();
    }, [filters])
    const getReports = (type) => {  
        let config = {
            params:filters,
            headers: {'Accept': type==2 ? 'application/pdf':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
            responseType: "blob"
        }

        resourcesInstallations('get',config).then(response => {
            if(type==1){
                console.log(response)
                const url = URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                    'download',
                    'Reporte de Excesos.xlsx'
                    )
                document.body.appendChild(link)
                link.click()
                
            }else{
                let nombre = 'Archivo';
                var reader = new FileReader();
                reader.readAsDataURL(response);
                reader.fileName = nombre[1] || nombre[0];
                reader.onloadend = function (name) {
                    name = nombre[0];
                    var base64data = reader.result;
                    setModalPdf({show:true,update:false,url:base64data});
                };    
            }
            
        })
    }

    const addUpd = (row=false) => {
        if(row.id){
            setItem(row)
            setModal({...modal,show:true,update:true})
        }else{
            console.log(itemBase)
            setItem(itemBase)
            setModal({...modal,show:true,update:false})
        }
    }
    const destroy = (id) => {
        DestroyAlertHelper(async confirmed => {
            if (!confirmed) { return; }
            resourcesInstallations('del',id,id).then(response => {
                Alert(response.message,response.status)
                if (response.status) {
                    setItems(
                        items.filter(i => i.id != id)
                    );
                }           
            })
        });
    }
    useEffect(() => {
        let params={params:{select:true}}
        getUsers(params).then(response => {
            getSelectsInstallation(params).then(resp => {
                setSelects({...selects, tecnicos:response.data,rutas:resp.rutas})    
            })
        });
    }, [])

    const columns = Columns(addUpd,destroy);
	document.title = "Instalacion | Instalaciones";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="col-12">
                        <DataTableHelper tittle="Instalación" columns={columns} items={items} pending={pending} config={dataPag} filters={filters} setFilters={setFilters}>
                            <div className="mb-3">
                                <ButtonHelper
                                    addButon={ true }
                                    actionAddButon={addUpd}
                                    reportButons={true}
                                    actionReportButon={getReports}
                                />
                            </div>

                            <div className="col-sm-2">
                                
                                <label className="form-label">Técnicos:</label>
                                <Select
                                    style={{padding:'01.25rem 0.5rem'}}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isClearable={true}
                                    defaultValue={tecnico}
                                    isSearchable={false}
                                    name="week"
                                    placeholder='Tecnico'
                                    options={selects.tecnicos}
                                    getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option.id}`}
                                    onChange={ e => [setTecnico(e),setFilters({...filters,tecnico_id:e ? e.id : null})] }
                                />
                            
                            </div>
                            <div className="col-sm-2">
                                    <label className="form-label">Rutas:</label>
                                    <Select
                                        style={{padding:'01.25rem 0.5rem'}}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isClearable={true}
                                        defaultValue={ruta}
                                        isSearchable={false}
                                        name="week"
                                        placeholder='Ruta'
                                        options={selects.rutas}
                                        getOptionLabel={(option) => `${option.no_ruta}`}
                                        getOptionValue={(option) => `${option.no_ruta}`}
                                        onChange={ e => [setRuta(e),setFilters({...filters,no_ruta:e ? e.no_ruta : null})] }
                                    />
                            </div>
                            <div className="col-sm-2">
                                <label className="form-label">Fecha Inicial:</label>
                                <div className="input-group input-group-md">
                                    <input
                                        type="date"
                                        className="form-control"
                                        placeholder='Fecha'
                                        aria-label="Recipient's username"
                                        aria-describedby="basic-addon2"
                                        value={filters.initDate}
                                        onChange={ e => setFilters({...filters, initDate:e.target.value}) }
                                    />
                                </div>
                            </div>
                            <div className="col-sm-2">
                                <label className="form-label">Fecha Final:</label>
                                <div className="input-group input-group-md">
                                    <input
                                        type="date"
                                        className="form-control"
                                        placeholder='Fecha'
                                        aria-label="Recipient's username"
                                        aria-describedby="basic-addon2"
                                        value={filters.endDate}
                                        onChange={ e => setFilters({...filters, endDate:e.target.value}) }
                                    />
                                </div>
                            </div>
                        </DataTableHelper>
                    </div>
                </Container>

                {modalPdf.show && (
                    <PreviewPDF modalPdf={modalPdf} setModalPdf={setModalPdf} />
                )}
                {modal.show &&
                    <AddUpdModal 
                        modal={modal}
                        setModal={setModal}
                        getInstallations={getInstallations}
                    />
                }
            </div>
        </React.Fragment>
    );
};

export default Installations;